import { useNavigate } from 'react-router-dom';
import './EkipSectionTabs.css';

const TABS = [
  {
    id: 'people',
    label: 'Kişiler',
    search: '?section=ekip',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
      </svg>
    ),
  },
  {
    id: 'assignments',
    label: 'Şube ataması',
    search: '?section=ekip&view=assignments',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
  },
];

export function getEkipSubTab(view) {
  return view === 'assignments' ? 'assignments' : 'people';
}

/** @deprecated Use getEkipSubTab — kept for any legacy imports */
export function getEkipPrimaryTab() {
  return 'ekip';
}

export default function EkipSectionTabs({ subTab }) {
  const navigate = useNavigate();

  return (
    <div className="ekip-section-nav">
      <div className="ekip-section-tabs" role="tablist" aria-label="Ekip">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            className="ekip-section-tab"
            aria-selected={subTab === tab.id}
            onClick={() => navigate({ pathname: '/dashboard', search: tab.search })}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
